import { Address, DigitalAddress, DigitalOrderRequestBody } from '../../../global-types';
import { useAddressStore } from '../../../stores/address';
import { getCookie, getDateString } from '../../../utils';
import { GetOrderRequestBodyProps } from '../preview-types';

// `contact_info` is the discriminant unique to DigitalAddress (absent from Address)
const isDigitalAddress = (address: DigitalAddress | Address | null): address is DigitalAddress =>
  address !== null && 'contact_info' in address;

/**
 * Builds the request body for the digital-orders API
 * @param initializeDataStatate
 * @param cardPreviewImages array
 * @param btlyUrl string
 */
export const getOrderRequestBody = ({
  initializedDataState,
  cardPreviewImages,
  btlyUrl,
  recipientTypeCode = 'E',
}: GetOrderRequestBodyProps) => {
  const digital = useAddressStore.getState().addressData.digital;
  if (!isDigitalAddress(digital)) {
    throw new Error('getOrderRequestBody requires a digital address');
  }
  const addressData = digital;
  const productData = initializedDataState.data?.product;
  const previewImage = cardPreviewImages[0].url || '';
  const projectId = initializedDataState.data?.project_id || '';
  const productId = initializedDataState.data?.product_id || '';
  const customer_number = getCookie('sfcno') || '';
  const purchaseDate = getDateString();
  const orderRequestBody: DigitalOrderRequestBody = {
    customer_no: customer_number,
    customer_crown_card_number: '', // Keep blank for now
    enterprise_consumer_id: '', // Keep blank for now
    project_id: projectId,
    project_source_code: 'W',
    purchase_date: purchaseDate,
    sender_first_name: addressData.sender_first_name,
    sender_last_name: addressData.sender_last_name,
    product_name: productData?.product_name || '',
    product_id: productId,
    preview_image_url: previewImage,
    contact_info: addressData.contact_info, // Recipient email address
    sender_email: addressData.sender_email,
    recipient_type_code: recipientTypeCode,
    tiny_url: btlyUrl,
  };

  return { orderRequestBody, purchaseDate, projectId };
};
